import { Capacitor } from '@capacitor/core';

export function isIosApp() {
  return Capacitor.getPlatform() === 'ios';
}

export function isAndroidApp() {
  return Capacitor.getPlatform() === 'android';
}

// App Store and Play Store builds cannot collect payment for digital programs.
export function isStoreApp() {
  return isIosApp() || isAndroidApp();
}

export const STORE_PURCHASE_ROUTE_NAMES = [
  'enroll',
  'client-enroll',
  'enroll_new',
  'client-enroll_new',
  'update_payment_method',
  'client-update_payment_method',
];
